import React, { Component } from "react";
import Fetch from "../../utils/fetch";
import { Table, Modal, Tabs, Checkbox, message, Input, Radio } from "antd";
import Search from "../../components/auditSearch/audits";
import Loader from "../../components/loader";
import moment from "moment";

const { TabPane } = Tabs;

const columns = [
  {
    title: "Bus RC",
    dataIndex: "rc",
    key: "rc"
  },
  {
    title: "Label",
    dataIndex: "label",
    key: "label"
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt"
  },
  {
    title: "Completed at",
    dataIndex: "completed",
    key: "completed"
  },
  {
    title: "Completed by user",
    dataIndex: "completedBy",
    key: "completedBy",
    render: ({ name, number }) => (
      <>
        <span>{name}</span>
        <br />
        <span>{number}</span>
      </>
    )
  },
  {
    title: "Audited by user",
    dataIndex: "auditedBy",
    key: "auditedBy"
  },
  {
    title: "Audited at time",
    dataIndex: "auditedAt",
    key: "auditedAt"
  },
  {
    title: "Complaince Status",
    dataIndex: "auditStatus",
    key: "auditStatus"
  },
  {
    title: "Fault Attribution",
    dataIndex: "auditCompletionStatus",
    key: "auditCompletionStatus"
  },
  {
    title: "REMARKS",
    dataIndex: "remarks",
    key: "remarks"
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    render: ({ view, _id }) => (
      <span
        onClick={() => view(_id)}
        style={{ color: "#1890ff", cursor: "pointer" }}
      >
        View
      </span>
    )
  }
];

class TripReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      audits: [],
      showAttachmentModal: false,
      viewData: null,
      activeTabIndex: 0,
      activeWorkIndex: 0,
      activeAttachmentIndex: 0,
      seenAttachments: {},
      showFaultModal: false,
      auditReasonList: [],
      auditRemark: ""
    };
    this.workRefs = [];
    this.handleNextMedia = this.handleNextMedia.bind(this);
    this.handlePreviousMedia = this.handlePreviousMedia.bind(this);
  }

  async componentDidMount() {
    try {
      const audits = await this.fetchWorkAudits();
      this.setState({
        loading: false,
        audits: audits.tableAudit,
        auditData: audits.response
      });
      this.markAttachmentSeen();
    } catch (err) {
      console.log(err);
    }
  }

  async fetchWorkAudits() {
    const url = `/workAuditHistory/search`;
    const options = { method: "get" };
    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      const tableAudit = this.formatData(response);
      return { tableAudit, response };
    } else {
      message.error("Nothing To show");
      return { tableAudit: [], response: [] };
    }
  }

  formatData(values) {
    return values.map(value => ({
      key: value._id,
      rc: value.busRc,
      label: value.label,
      createdAt: moment(value.createdOn).format("h:mm a, DD MMM YY"),
      completed: moment(value.closedDate).format("h:mm a, DD MMM YY"),
      completedBy: {
        name: value.closedByUser.name,
        number: value.closedByUser.mobileNo
      },
      auditedBy: value.auditedByUserId ? value.auditedByUser.name : "NA",
      auditedAt: value.auditedByUserId
        ? moment(value.auditedOn).format("h:mm a, DD MMM YY")
        : "NA",
      remarks: value.auditRemark,
      auditCompletionStatus: Array.isArray(value.auditReasonList)
        ? value.auditReasonList.join(", ")
        : value.auditReason
        ? value.auditReason
        : "NA",
      auditStatus: value.auditStatus,
      actions: {
        _id: value._id,
        view: this.viewData.bind(this)
      }
    }));
  }
  scrollActiveWorkIntoView = () => {
    const currentRef = this.workRefs[this.state.activeWorkIndex];
    if (currentRef && currentRef.scrollIntoView) {
      currentRef.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  };
  viewData(_id) {
    this.setState(
      prevState => {
        const viewData = prevState.auditData.find(d => d._id === _id);

        return {
          showAttachmentModal: true,
          viewData,
          activeTabIndex: 0,
          activeWorkIndex: 0,
          activeAttachmentIndex: 0,
          seenAttachments: {}
        };
      },
      () => {
        this.markAttachmentSeen();
      }
    );
  }

  getCurrentGroup() {
    const { viewData, activeTabIndex } = this.state;
    return viewData && viewData.groupWork && viewData.groupWork[activeTabIndex];
  }

  getCurrentWork() {
    const group = this.getCurrentGroup();
    return group && group.work && group.work[this.state.activeWorkIndex];
  }

  getCurrentAttachment() {
    const work = this.getCurrentWork();
    return (
      work &&
      work.attachments &&
      work.attachments[this.state.activeAttachmentIndex]
    );
  }

  handleNextMedia() {
    const groupWork = this.state.viewData.groupWork;
    let { activeTabIndex, activeWorkIndex, activeAttachmentIndex } = this.state;

    const group = groupWork[activeTabIndex];
    const work = group.work[activeWorkIndex];
    const attachments = work.attachments || [];

    if (activeAttachmentIndex + 1 < attachments.length) {
      this.setState(
        { activeAttachmentIndex: activeAttachmentIndex + 1 },
        this.scrollActiveWorkIntoView
      );
    } else if (activeWorkIndex + 1 < group.work.length) {
      this.setState(
        {
          activeWorkIndex: activeWorkIndex + 1,
          activeAttachmentIndex: 0
        },
        this.scrollActiveWorkIntoView
      );
    } else if (activeTabIndex + 1 < groupWork.length) {
      this.setState(
        {
          activeTabIndex: activeTabIndex + 1,
          activeWorkIndex: 0,
          activeAttachmentIndex: 0
        },
        this.scrollActiveWorkIntoView
      );
    }
    this.markAttachmentSeen();
  }

  handlePreviousMedia() {
    let { activeTabIndex, activeWorkIndex, activeAttachmentIndex } = this.state;
    const group = this.state.viewData.groupWork[activeTabIndex];

    if (activeAttachmentIndex > 0) {
      this.setState(
        { activeAttachmentIndex: activeAttachmentIndex - 1 },
        this.scrollActiveWorkIntoView
      );
    } else if (activeWorkIndex > 0) {
      const prevWork = group.work[activeWorkIndex - 1];
      const prevAttachments = prevWork.attachments || [];
      this.setState(
        {
          activeWorkIndex: activeWorkIndex - 1,
          activeAttachmentIndex: prevAttachments.length - 1
        },
        this.scrollActiveWorkIntoView
      );
    } else if (activeTabIndex > 0) {
      this.setState(prevState => {
        const { viewData, activeTabIndex } = prevState;
        const prevGroup = viewData.groupWork[activeTabIndex - 1];
        const prevWork = prevGroup.work[prevGroup.work.length - 1];
        const prevAttachments = prevWork.attachments || [];

        return {
          activeTabIndex: activeTabIndex - 1,
          activeWorkIndex: prevGroup.work.length - 1,
          activeAttachmentIndex: prevAttachments.length - 1
        };
      }, this.scrollActiveWorkIntoView);
    }
    this.markAttachmentSeen();
  }

  renderMedia() {
    const attachment = this.getCurrentAttachment();
    if (!attachment || !attachment.attachmentUrl) {
      return <span>No Media</span>;
    }
    const url = `https://d370edwo3kkakj.cloudfront.net/${attachment.attachmentUrl}`;
    if (attachment.attachmentType === "image") {
      return (
        <img
          src={url}
          alt="attachment"
          style={{ width: "100%", maxHeight: 400, objectFit: "contain" }}
        />
      );
    }
    if (attachment.attachmentType === "audio") {
      return <audio controls src={url} style={{ width: "100%" }} />;
    }
    if (attachment.attachmentType === "video") {
      return (
        <video controls src={url} width="100%" style={{ maxHeight: 400 }} />
      );
    }
    return null;
  }
  markAttachmentSeen = () => {
    const {
      activeTabIndex,
      activeWorkIndex,
      activeAttachmentIndex,
      seenAttachments
    } = this.state;
    const key = `${activeTabIndex}-${activeWorkIndex}-${activeAttachmentIndex}`;
    if (!seenAttachments[key]) {
      this.setState(prev => ({
        seenAttachments: { ...prev.seenAttachments, [key]: true }
      }));
    }
  };

  searchResults = data => {
    if (data) {
      const tableAudit = this.formatData(data);
      this.setState({
        loading: false,
        audits: tableAudit,
        auditData: data
      });
      this.markAttachmentSeen();
    } else {
      throw new Error("No response");
    }
  };

  updateComplaint = async (id, auditStatus) => {
    const url = `/workAuditHistory/auditUpdate`;

    const options = {
      method: "post",
      data: { id, auditStatus }
    };
    const auditResponse = await Fetch(url, options);

    if (Array.isArray(auditResponse) && auditResponse.length > 0) {
      const updatedAudit = auditResponse[0];
      const { auditData } = this.state;

      const newAuditData = auditData.map(audit =>
        audit._id === updatedAudit._id ? { ...audit, ...updatedAudit } : audit
      );

      const data = this.formatData(newAuditData);
      this.setState({
        audits: data,
        auditData: newAuditData,
        showAttachmentModal: false,
        viewData: undefined,
        activeTabIndex: 0,
        activeWorkIndex: 0,
        activeAttachmentIndex: 0,
        seenAttachments: {}
      });
    }
  };

  updateNonComplaint = async id => {
    this.setState({ showFaultModal: true, selectedAuditId: id });
  };

  updateFault = async () => {
    const { selectedAuditId, auditReasonList, auditRemark } = this.state;
    const url = `/workAuditHistory/auditUpdate`;

    if (!auditReasonList || auditReasonList.length === 0) {
      message.error("Please select Fault Attribution");
      return;
    }

    const options = {
      method: "post",
      data: {
        id: selectedAuditId,
        auditStatus: "NON-COMPLIANT",
        auditReasonList: auditReasonList,
        auditRemark
      }
    };
    const auditResponse = await Fetch(url, options);

    if (Array.isArray(auditResponse) && auditResponse.length > 0) {
      const updatedAudit = auditResponse[0];
      const { auditData } = this.state;

      const newAuditData = auditData.map(audit =>
        audit._id === updatedAudit._id ? { ...audit, ...updatedAudit } : audit
      );

      const data = this.formatData(newAuditData);
      this.setState({
        showFaultModal: false,
        audits: data,
        auditData: newAuditData,
        showAttachmentModal: false,
        viewData: undefined,
        activeTabIndex: 0,
        activeWorkIndex: 0,
        auditReasonList: [],
        auditRemark: "",
        activeAttachmentIndex: 0,
        seenAttachments: {}
      });
    }
  };

  updateFaultStatus = (key, value) => {
    this.setState({ [key]: value });
  };

  render() {
    const {
      audits,
      loading,
      showAttachmentModal,
      viewData,
      activeTabIndex,
      seenAttachments,
      showFaultModal,
      auditRemark,
      auditReasonList
    } = this.state;

    if (loading) return <Loader />;

    return (
      <div>
        <Search fetched={this.searchResults} />
        <Table
          columns={columns}
          dataSource={audits}
          pagination={false}
          scroll={{ y: "70vh" }}
        />
        <Modal
          visible={showAttachmentModal}
          title="Media Viewer"
          centered
          width="90%"
          onCancel={() => this.setState({ showAttachmentModal: false })}
          footer={null}
        >
          {viewData && (
            <>
              <Tabs
                activeKey={String(activeTabIndex)}
                onChange={key =>
                  this.setState({
                    activeTabIndex: parseInt(key, 10),
                    activeWorkIndex: 0,
                    activeAttachmentIndex: 0
                  })
                }
              >
                {viewData.groupWork.map((group, tabIndex) => (
                  <TabPane tab={group.label} key={String(tabIndex)}>
                    <div style={{ display: "flex", gap: 24, height: "500px" }}>
                      {/* Left: Media */}
                      <div style={{ flex: 2, position: "relative" }}>
                        <div style={{ textAlign: "center" }}>
                          <div
                            style={{ height: 400, backgroundColor: "#f0f0f0" }}
                          >
                            {this.renderMedia()}
                          </div>
                          <div
                            style={{
                              marginTop: 10,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 20
                            }}
                          >
                            <button onClick={this.handlePreviousMedia}>
                              ◀
                            </button>
                            <div
                              style={{
                                textAlign: "center",
                                width: "200px"
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {this.getCurrentAttachment() &&
                                this.getCurrentAttachment().attachmentLabel
                                  ? this.getCurrentAttachment().attachmentLabel
                                  : "No Attachment"}
                              </div>
                              <div style={{ fontSize: 12, color: "#888" }}>
                                {this.getCurrentWork() &&
                                this.getCurrentWork().label
                                  ? this.getCurrentWork().label
                                  : "No Work Selected"}
                              </div>
                            </div>
                            <button onClick={this.handleNextMedia}>▶</button>
                          </div>
                        </div>
                      </div>

                      {/* Right: Work info */}
                      <div style={{ flex: 1 }}>
                        <div style={{ height: "400px", overflow: "auto" }}>
                          {group.work.map((work, idx) => (
                            <div
                              key={work.id}
                              style={{ marginBottom: 16 }}
                              ref={el => (this.workRefs[idx] = el)}
                            >
                              <Radio
                                checked={this.state.activeWorkIndex === idx}
                                onClick={() =>
                                  this.setState(
                                    {
                                      activeWorkIndex: idx,
                                      activeAttachmentIndex: 0
                                    },
                                    () => {
                                      this.markAttachmentSeen();
                                    }
                                  )
                                }
                              >
                                <strong
                                  style={{
                                    fontSize: "20px"
                                  }}
                                >
                                  {work.label}
                                </strong>
                              </Radio>
                              <div>
                                {" "}
                                <strong>Value:</strong> {work.value}
                              </div>
                              <div>
                                {" "}
                                <strong>Remark:</strong>{" "}
                                {work.remark || "No Remarks"}
                              </div>
                              {work.attachments && work.attachments.length > 0 && (
                                <div style={{ marginTop: 8 }}>
                                  <div>
                                    <strong>Attachments:</strong>
                                  </div>
                                  <Radio.Group
                                    value={this.state.activeAttachmentIndex}
                                    onChange={e =>
                                      this.setState(
                                        {
                                          activeAttachmentIndex: e.target.value
                                        },
                                        () => {
                                          this.markAttachmentSeen();
                                        }
                                      )
                                    }
                                  >
                                    {work.attachments.map((att, i) => (
                                      <Radio
                                        key={i}
                                        value={i}
                                        style={{
                                          display: "block",
                                          marginLeft: 8
                                        }}
                                      >
                                        {att.attachmentLabel}{" "}
                                        {att.attachmentUrl ? (
                                          seenAttachments[
                                            `${activeTabIndex}-${idx}-${i}`
                                          ] ? (
                                            <span style={{ color: "#52c41a" }}>
                                              👁 Seen
                                            </span>
                                          ) : (
                                            <span style={{ color: "#aaa" }}>
                                              Not Viewed
                                            </span>
                                          )
                                        ) : (
                                          <span style={{ color: "#aaa" }}>
                                            Not Uploaded
                                          </span>
                                        )}
                                      </Radio>
                                    ))}
                                  </Radio.Group>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </TabPane>
                ))}
              </Tabs>
              {viewData.auditStatus == "COMPLIANT" ||
              viewData.auditStatus === "NON-COMPLIANT" ? null : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 24,
                    gap: 16
                  }}
                >
                  <button
                    onClick={() =>
                      this.updateNonComplaint(viewData._id, "NON-COMPLIANT")
                    }
                    style={{
                      backgroundColor: "#e67e22",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      padding: "10px 20px",
                      fontWeight: "bold",
                      cursor: "pointer"
                    }}
                  >
                    Not Complaint
                  </button>
                  <button
                    onClick={() =>
                      this.updateComplaint(viewData._id, "COMPLIANT")
                    }
                    style={{
                      backgroundColor: "#8e44ad",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      padding: "10px 20px",
                      fontWeight: "bold",
                      cursor: "pointer"
                    }}
                  >
                    Mark as Complaint
                  </button>
                </div>
              )}
            </>
          )}
        </Modal>
        <Modal
          title="FAULT ATTRIBUTION "
          visible={showFaultModal}
          okText="Save"
          onOk={this.updateFault}
          onCancel={() =>
            this.setState({
              showFaultModal: false,
              auditRemark: undefined,
              auditReasonList: []
            })
          }
        >
          <div>
            <span>Fault of </span>{" "}
            <Checkbox.Group
              options={[
                { label: "CREW", value: "MARSHAL" },
                { label: "BUS", value: "BUS" }
              ]}
              value={auditReasonList || []}
              onChange={value =>
                this.updateFaultStatus("auditReasonList", value)
              }
            />
          </div>
          <Input
            value={auditRemark}
            placeholder="Enter Remark"
            onChange={e =>
              this.updateFaultStatus("auditRemark", e.target.value)
            }
          />
        </Modal>
      </div>
    );
  }
}

export default TripReview;
